export class Pagination {
  constructor(difference) {
    this.isSystemComponent = true
    this.isIndependenceComponent = true
    this.isDefaultComponent = true
    this.width = "auto"
    this.widthType = "自动"
    this.height = 32 // 自适应也给个默认值，不然拖出来所在布局没有高度
    this.heightType = "自动"
    this.resizable = false
    this.left = 0
    this.top = 4
    this.innerElement = "cxPagination"
    this.fontFamily = "sans-serif"
    this.fontSize = 14
    this.fontWeight = 400
    this.color = "rgba(0,0,0,0.8)"
    this.textIsThemeColor = false
    this.bgColor = "rgba(255, 255, 255, 1)"
    this.lineHeight = 32
    this.letterSpacing = 0
    this.textDecoration = "none"
    this.fontStyle = "normal"
    this.itemMargin = 10
    this.minWidth = 32
    this.hideOnSinglePage = true
    this.showJumper = false
    this.showTotal = false
    this.total = 2000
    this.pageSize = 10
    this.maxPageBtnNum = 7 //最大页面按钮数量
    this.value = 1

    this.otherFontSize = 12
    this.otherFontColor = "rgba(0, 0, 0, 0.6)"
    this.otherFontFamily = "sans-serif"
    this.otherFontWeight = 400

    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 8
    this.paddingLeft = 8
    this.paddingBottom = 0
    this.paddingTypeFlag = 2

    this.borderTopLeftRadius = 8
    this.borderTopRightRadius = 8
    this.borderBottomLeftRadius = 8
    this.borderBottomRightRadius = 8
    this.borderColor = "rgba(237, 241, 246, 1)"
    this.borderStyle = "solid"
    this.borderWidth = 1
    this.borderIsThemeColor = false

    this.activeColor = "rgba(255, 255, 255, 1)"
    this.activeFontFamily = "sans-serif"
    this.activeFontWeight = "400"
    this.activeFontSize = 14

    this.activeBgColor = "rgba(61, 130, 242, 1)"
    this.activeBgColorIsThemeColor = true

    this.activeBoxShadowColor = ["rgba(255,255,255,1)"]
    this.activeBoxShadowH = [0]
    this.activeBoxShadowV = [0]
    this.activeBoxShadowBlur = [0]
    this.activeBoxShadowSpread = [0]

    this.activeBorderTopLeftRadius = 8
    this.activeBorderTopRightRadius = 8
    this.activeBorderBottomRightRadius = 8
    this.activeBorderBottomLeftRadius = 8

    this.activeBorderWidth = 1
    this.activeBorderStyle = "solid"
    this.activeBorderColor = "rgba(255, 255, 255, 0)"
    this.activeBorderIsThemeColor = false

    this.activePaddingTypeFlag = 2
    this.activePadding = 0
    this.activePaddingTop = 0
    this.activePaddingRight = 8
    this.activePaddingLeft = 8
    this.activePaddingBottom = 0

    this.hoverColor = "rgba(0, 0, 0, 0.8)"
    this.hoverFontFamily = "sans-serif"
    this.hoverFontWeight = "400"
    this.hoverFontSize = 14

    this.hoverBgColor = "rgba(250, 251, 254, 1)"
    this.hoverBgColorIsThemeColor = false

    this.hoverBoxShadowColor = ["rgba(255,255,255,1)"]
    this.hoverBoxShadowH = [0]
    this.hoverBoxShadowV = [0]
    this.hoverBoxShadowBlur = [0]
    this.hoverBoxShadowSpread = [0]

    this.hoverBorderTopLeftRadius = 8
    this.hoverBorderTopRightRadius = 8
    this.hoverBorderBottomRightRadius = 8
    this.hoverBorderBottomLeftRadius = 8

    this.hoverBorderWidth = 1
    this.hoverBorderStyle = "solid"
    this.hoverBorderColor = "rgba(237, 241, 246, 1)"
    this.hoverBorderIsThemeColor = false

    this.hoverPaddingTypeFlag = 2
    this.hoverPadding = 0
    this.hoverPaddingTop = 0
    this.hoverPaddingRight = 8
    this.hoverPaddingLeft = 8
    this.hoverPaddingBottom = 0

    this.pageTurnType = "icon" //icon text
    this.pageTurnIcon = "icon-portal-arrows-left"
    this.pageTurnIconColor = "rgba(0,0,0,.6)"
    this.pageTurnIconIsThemeColor = false

    this.pageTurnFontSize = 16
    this.pageTurnFontColor = "rgba(0, 0, 0, 0.6)"
    this.pageTurnFontFamily = "sans-serif"
    this.pageTurnFontWeight = 400

    this.pageTurnHeight = 32
    this.pageTurnMinWidth = 32
    this.pageTurnBgColor = "rgba(255, 255, 255, 1)"
    this.pageTurnBgIsThemeColor = false

    this.pageTurnBorderColor = "rgba(237, 241, 246, 1)"
    this.pageTurnBorderStyle = "solid"
    this.pageTurnBorderWidth = 1
    this.pageTurnBorderIsThemeColor = false

    this.pageTurnPadding = 0
    this.pageTurnPaddingTop = 0
    this.pageTurnPaddingRight = 4
    this.pageTurnPaddingLeft = 4
    this.pageTurnPaddingBottom = 0
    this.pageTurnPaddingTypeFlag = 1

    this.pageTurnBorderTypeFlag = 1
    this.pageTurnBorderRadius = 8
    this.pageTurnBorderTopLeftRadius = 8
    this.pageTurnBorderTopRightRadius = 8
    this.pageTurnBorderBottomLeftRadius = 8
    this.pageTurnBorderBottomRightRadius = 8

    this.hoverPageTurnIconColor = "rgba(0,0,0,.6)"
    this.hoverPageTurnFontColor = "rgba(0,0,0,0.6)"

    this.hoverPageTurnBgColor = "rgba(250, 251, 254, 1)"
    this.hoverPageTurnBgIsThemeColor = false

    this.hoverPageTurnBorderColor = "rgba(237, 241, 246, 1)"
    this.hoverPageTurnBorderStyle = "solid"
    this.hoverPageTurnBorderWidth = 1
    this.hoverPageTurnBorderIsThemeColor = false

    this.hoverPageTurnPadding = 0
    this.hoverPageTurnPaddingTop = 0
    this.hoverPageTurnPaddingRight = 4
    this.hoverPageTurnPaddingLeft = 4
    this.hoverPageTurnPaddingBottom = 0
    this.hoverPageTurnPaddingTypeFlag = 1

    this.hoverPageTurnBorderTypeFlag = 1
    this.hoverPageTurnBorderRadius = 8
    this.hoverPageTurnBorderTopLeftRadius = 8
    this.hoverPageTurnBorderTopRightRadius = 8
    this.hoverPageTurnBorderBottomLeftRadius = 8
    this.hoverPageTurnBorderBottomRightRadius = 8

    this.bgColorIsThemeColor = false
    this.hoverBgColorIsThemeColor = false
    this.opacity = 100
    this.bgType = "纯色" //纯色 线性渐变 径向渐变
    this.bgStartColor = "rgba(23,241,255,1)"
    this.bgEndColor = "rgba(23,116,255,1)"
    this.boxShadowColor = ["rgba(255,255,255,1)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]

    this.allBoxShadowColor = ["rgba(255,255,255,1)"]
    this.allBoxShadowH = [0]
    this.allBoxShadowV = [0]
    this.allBoxShadowBlur = [0]
    this.allBoxShadowSpread = [0]
    this.allBorderTopLeftRadius = 0
    this.allBorderTopRightRadius = 0
    this.allBorderBottomLeftRadius = 0
    this.allBorderBottomRightRadius = 0
    this.allBorderWidth = 0
    this.allBorderStyle = "solid"
    this.allBorderColor = "#000000"
    this.allBorderIsThemeColor = false
    this.allPadding = 0
    this.allPaddingTop = 0
    this.allPaddingRight = 0
    this.allPaddingLeft = 0
    this.allPaddingBottom = 0
    this.background = [] // 全局背景

    this.contentHasLimit = true
    this.textLimitLines = 4
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
